import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SyracuseHero from './components/SyracuseHero';
import SyracuseTrust from './components/SyracuseTrust';
import SyracuseServices from './components/SyracuseServices';
import SyracuseNeighborhoods from './components/SyracuseNeighborhoods';
import SyracuseTestimonial from './components/SyracuseTestimonial';
import SyracuseContact from './components/SyracuseContact';

export default function SyracusePage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Syracuse Utah Disaster Cleanup & Restoration | Water Damage, Mold, Fire | Davis County Disaster Cleanup';

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Syracuse\'s trusted disaster cleanup and restoration experts. 24/7 emergency response for water damage, flood cleanup, mold remediation, fire damage, and storm restoration. IICRC certified technicians serving all Syracuse neighborhoods. Call (385) 340-6632 for immediate assistance.');
    setMeta('keywords', 'Syracuse disaster cleanup, Syracuse water damage restoration, Syracuse flood cleanup, Syracuse mold remediation, Syracuse fire damage restoration, Syracuse storm damage repair, emergency restoration Syracuse Utah');
    setMeta('geo.position', '41.0894;-112.0647');
    setMeta('geo.placename', 'Syracuse, Utah');
    setMeta('geo.region', 'US-UT');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://daviscountydisastercleanup.com/syracuse');

    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Do you provide 24/7 emergency restoration services in Syracuse?',
          acceptedAnswer: { '@type': 'Answer', text: 'Yes, we provide 24/7 emergency disaster cleanup and restoration services throughout Syracuse, Utah. Our local team responds within 60 minutes to water damage, fire damage, flood cleanup, and other emergencies.' },
        },
        {
          '@type': 'Question',
          name: 'What areas of Syracuse do you serve?',
          acceptedAnswer: { '@type': 'Answer', text: 'We serve all Syracuse neighborhoods including Bluff Ridge, Syracuse Meadows, Lakeside Village, Antelope Ridge, West Point Estates, and Syracuse Hills.' },
        },
        {
          '@type': 'Question',
          name: 'Are your technicians certified for restoration work?',
          acceptedAnswer: { '@type': 'Answer', text: 'Yes, all our restoration technicians are IICRC certified and trained in the latest water damage restoration, mold remediation, fire damage cleanup, and disaster recovery techniques.' },
        },
        {
          '@type': 'Question',
          name: 'Do you work with insurance companies for Syracuse restoration claims?',
          acceptedAnswer: { '@type': 'Answer', text: 'Yes, we work directly with all major insurance companies and help Syracuse homeowners navigate the claims process with detailed documentation and adjuster communication.' },
        },
      ],
    };

    let schemaScript = document.querySelector('script[data-page="syracuse-faq"]') as HTMLScriptElement | null;
    if (!schemaScript) {
      schemaScript = document.createElement('script');
      schemaScript.setAttribute('type', 'application/ld+json');
      schemaScript.setAttribute('data-page', 'syracuse-faq');
      document.head.appendChild(schemaScript);
    }
    schemaScript.textContent = JSON.stringify(faqSchema);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <SyracuseHero />
        <SyracuseTrust />
        <SyracuseServices />
        <SyracuseNeighborhoods />
        <SyracuseTestimonial />
        <SyracuseContact />
      </main>
      <Footer />
    </div>
  );
}
